import { LayoutContainer } from '@ui/LayoutContainer';
import { CatalogSkeleton } from '@components/catalog/Catalog/CatalogSkeleton';

export const CatalogPageSkeleton = () => (
  <LayoutContainer>
    <CatalogSkeleton />
  </LayoutContainer>
);
